<!-- 线上病历详情 -->
<template>
  <div class="medical-record-detail">
    <a-spin :spinning="loading">
      <!-- <div class="patientIsSee" v-if="!isOnLine && info.base.patientPermission === 0">
        <auth-img mode='ant'
          :preview="false"
          :width="124"
          :height="44"
          :src="patientIsSee"
          class="medical-img"
        />
      </div> -->
      <div class="chapter" v-if="!isOnLine && !isHisOffLineRecord">
        <!-- 添加可见不可见图片 -->
        <div class="pChapterImg" v-if="!info.base.patientPermission">
          <auth-img mode="ant" height="50px" :src="pInvisibleImg" :preview="false" />
        </div>
        <div class="daChapterImg" v-if="!info.base.doctorPermission">
          <auth-img mode="ant" height="50px" :src="dInvisibleImg" :preview="false" />
        </div>
        <div class="daChapterImg" v-if="!info.base.assistPermission">
          <auth-img mode="ant" height="50px" :src="aInvisibleImg" :preview="false" />
        </div>
      </div>
      <div v-if="isOnLine" class="annotation">
        <span>创建时间：{{ info.base.createAt || '--' }}</span>
      </div>
      <div
        v-else
        class="annotationBox"
        :style="{ justifyContent: isTraceRecordShow ? 'space-between' : 'flex-end' }"
      >
        <div v-if="isTraceRecordShow" class="history" @click="handleHistory">查看历史核验结果</div>
        <div class="annotation">
          <template v-if="isHisOffLineRecord">
            <span v-if="info.base.medicalDate">
              院内数据获取：{{ info.base.medicalDate || '--' }}
            </span>
          </template>
          <template v-else>
            <template v-if="info.base.createAt">
              <!-- 上传时间 -->
              <span>上传时间：{{ info.base.createAt || '--' }}</span>
              <span>
                上传人：
                <label>{{ calcUpload(info.base, 'createBy') || '--' }}</label>
              </span>
            </template>
            <!-- 编辑时间 -->
            <template v-if="info.base.changeAt">
              <span>编辑时间：{{ info.base.changeAt || '--' }}</span>
              <span>
                编辑人：
                <label>{{ calcUpload(info.base, 'changeName') || '--' }}</label>
              </span>
            </template>
          </template>
        </div>
      </div>
      <h3 class="baseTitle">{{ isOnLine ? '基本信息' : '' }}</h3>
      <div class="detail_info" :class="{ 'detail_info-record': !isOnLine }">
        <div
          v-for="column in recordLabels"
          :class="column.class + 'Label'"
          class="detail_info-item"
          :key="column"
        >
          <label class="item_label">{{ column.label }}：</label>
          <div class="item_content img_content" v-if="column.type == 'img'">
            <a-row
              v-if="
                (info.base.imgList && info.base.imgList.length) ||
                (info.base.imgUrls && info.base.imgUrls.length)
              "
            >
              <div class="recordImg" v-for="img in info.base[column.prop]" :key="img.uuid">
                <auth-img
                  mode="ant"
                  class="medical-img"
                  alt="病历"
                  width="100%"
                  height="100%"
                  :src="img.url || img"
                />
              </div>
            </a-row>
            <a-row v-else>--</a-row>
          </div>
          <!-- 中医证型 -->
          <span v-else-if="column.prop === 'chineseDiagnosis'" class="item_content">
            {{
              calcDiagnosis(
                info.base,
                'chineseDiagnosis',
                isOnLine ? 'diagnosisNames' : 'offlineDiagnosis'
              )
            }}
          </span>
          <!-- 复诊日期 -->
          <span v-else-if="column.prop === 'cureReserveOrderVO'" class="item_content">
            <span v-if="info.base.cureReserveOrderVO">
              {{ handleTimeShowWeek(info.base.cureReserveOrderVO.reserveDate) }}
              {{ ['上午', '下午'][info.base.cureReserveOrderVO.reserveDateDetail - 1] || '' }}
              {{ ['线上问诊', '门诊就诊'][info.base.cureReserveOrderVO.revisitType - 1] || '' }}
            </span>
            <span v-else>遵医嘱复诊</span>
          </span>
          <!-- 西医诊断 -->
          <span v-else-if="column && column.prop === 'westernDiagnosis'" class="item_content">
            {{ calcDiagnosis(info.base, 'westernDiagnosis', 'westernDiagnosis') }}
          </span>
          <span v-else-if="column.render" class="item_content">
            {{ column.render(info.base) }}
          </span>
          <!-- 嘱托 -->
          <span v-else-if="column.prop === 'taboo'" class="item_content">
            {{ getEntrust(info.base && info.base.taboo, info.base && info.base.advice) }}
          </span>
          <!-- 检查指标 -->
          <span v-else-if="column.prop === 'detailIndex' && info.base.caseType === 4">
            {{
              `体温${calcEmptyText(info.base.temperature)}度；
              体重${calcEmptyText(info.base.weight)}kg；
              心率${calcEmptyText(info.base.heartRete)}bpm；
              收缩压${calcEmptyText(info.base.systolic)}mmhg；
              舒张压${calcEmptyText(info.base.diastole)}mmhg；
              ${calcEmptyText(info.base.moreExamine, '')}`
            }}
          </span>
          <span class="item_content" v-else>
            {{ info.base[column.prop] || '--' }}
          </span>
        </div>
      </div>

      <a-divider class="separateLine" v-if="isOnLine" />
      <div class="head" v-if="!isHisOffLineRecord">
        <h3 class="head-left">药品信息</h3>
      </div>
      <!-- 线上药品信息列表 -->
      <!-- 中药处方 （历史协定方） -->
      <DrugTable
        v-if="isOnLine && onLineTableData.chineseMedicineInfo?.isHave"
        :presVisible="PreBtnVisible"
        :isCHINESE="true"
        :source="onLineTableData.chineseMedicineInfo.data"
        :info="info.base"
        :instanceBusinessType="info.base.instanceBusinessType"
        @prescription="
          emit('jumpTo', 'prescriptionOnline', '0', info.base.prescriptionNumber, { mode })
        "
      />
      <!-- 西药 -->
      <!--   :presVisible="PreBtnVisible" 使用插槽自定义按钮 -->
      <!--  @prescription="
          emit('jumpTo', 'prescriptionOnline', '0', info.base.prescriptionNumber, { mode })
        " -->
      <DrugTable
        v-if="isOnLine && onLineTableData.westernMedicineList?.isHave"
        :isCHINESE="false"
        :presVisible="false"
        :source="onLineTableData.westernMedicineList.data"
        :info="info.base"
        :instanceBusinessType="info.base.instanceBusinessType"
      >
        <!-- 使用插槽自定义按钮 -->
        <template v-slot:prescriptionBtn v-if="westernPList?.length > 0">
          <a-button
            type="link"
            v-for="(item, index) in westernPList"
            :key="index"
            @click="emit('jumpTo', 'prescriptionOnline', '0', item.serialNumber, { mode })"
          >
            查看处方
            <span v-if="westernPList?.length > 1">
              {{ index + 1 }}
            </span>
            详情
          </a-button>
        </template>
      </DrugTable>
      <!-- 协定方 -->
      <div v-if="isOnLine && onLineTableData.protocolPrescriptionInfos?.isHave">
        <DrugTable
          v-for="(c, i) in onLineTableData.protocolPrescriptionInfos?.data || []"
          :key="i"
          :presVisible="PreBtnVisible"
          :isCHINESE="true"
          :source="[
            {
              prescriptionName: c.prescriptionName,
              prescriptionNumber: c.prescriptionNumber,
              prescriptionSn: c.prescriptionSn
            }
          ]"
          :info="{
            ...info.base,
            chineseMedicineInfo: {
              ...c,
              dosageTypeStr: dosageTypeConf[c.dosageType] || '--'
            }
          }"
          :instanceBusinessType="1"
          @prescription="emit('jumpTo', 'prescriptionOnline', '0', c.serialNumber, { mode })"
        />
      </div>

      <!-- 线下药品信息 -->
      <BaseDrugInfo
        v-if="!isOnLine && !isHisOffLineRecord"
        :dInfo="info.base.prescriptionInfo"
        :infoBase="info.base"
      />

      <!-- <a-divider v-if="!isOnLine" class="separateLine" /> -->

      <!-- 线下检查单 -->
      <div class="detail_recode" v-if="!isOnLine && !isHisOffLineRecord">
        <div>
          <span class="baseTitle">检查检验单</span>
          <div
            class="img-container"
            v-if="
              info.base.checklistFileList &&
              info.base.checklistFileList.length &&
              isShowValue(info.base, !isOnLine)
            "
          >
            <a-row>
              <ImageWithName :fileList="info.base.checklistFileList" />
              <!-- <div class="recordImg" v-for="(img, idex) in info.base.checkList" :key="idex">
                <auth-img mode='ant' alt="检验单" width="100%" height="100%" :src="img" />
              </div> -->
            </a-row>
          </div>
          <span v-else>：--</span>
        </div>
        <div>
          <span class="baseTitle">量表图片</span>
          <div
            class="img-container"
            v-if="
              info.base.surveySendAnswerList &&
              info.base.surveySendAnswerList.length &&
              isShowValue(info.base, !isOnLine)
            "
          >
            <a-row>
              <ImageWithName :fileList="info.base.surveySendAnswerList" />
              <!-- <div class="recordImg" v-for="(img, idex) in info.base.checkList" :key="idex">
                <auth-img mode='ant' alt="检验单" width="100%" height="100%" :src="img" />
              </div> -->
            </a-row>
          </div>
          <span v-else>：--</span>
        </div>
      </div>
    </a-spin>
    <!-- 溯源码弹窗 -->
    <DrugTraceRecord ref="DrugTraceRecordRef" :list="traceRecordsList" />
  </div>
</template>
<script setup>
/**
 * @description 线上门诊病历详情  isOnLine ? 线上 ： 线下
 * @param visible（v-model） 显示隐藏
 * @param MRecordType  病历类型（病历 or 就医记录）
 * @param MRecordId 病历 ID
 */
import {
  onLineRecordDetail,
  offLineRecordDetail,
  isDetailIllnessPreById,
  hisOffLineRecordDetail,
  judgeTraceRecords,
  listTraceRecords
} from '@/api/HealthRecord/index.js'
import { getEntrust } from '@/utils/index'
import { offLineRecordConf, onLineRecordConf, isShowValue, dosageTypeConf } from './DetailConf'
import { defineProps, ref, defineEmits, reactive, watch } from 'vue'
import BaseDrugInfo from './BaseDrugInfo.vue'
import DrugTable from './onLineDrugTable.vue'
import { calcDiagnosis } from '@/utils/index'
import DrugTraceRecord from '@/components/DrugTraceRecord/index.vue'
import ImageWithName from '@/components/ImageWithName'
import { calcUpload, handleTimeShowWeek } from '@/utils'
const dInvisibleImg = require('@/assets/img/dInvisible.png')
const pInvisibleImg = require('@/assets/img/pInvisible.png')
const aInvisibleImg = require('@/assets/img/aInvisible.png')
const prop = defineProps({
  // 是否可见
  visible: {
    type: Boolean,
    required: true
  },
  // 病历类型
  MRecordType: {
    type: String,
    required: true,
    default: 'offLineRecord'
  },
  recordIsPre: {
    type: String,
    default: ''
  },
  // 病历详情id
  MRecordId: {
    type: String,
    required: true,
    default: ''
  },
  mode: {
    type: String,
    default: ''
  },
  // 操作类型
  MOperateType: {
    type: Number,
    default: null
  },
  // 患者PID
  MPid: {
    type: String,
    default: ''
  },
  // 医院ID
  MHospitalId: {
    type: Number,
    default: null
  },
  // uc患者ID
  MUcPatientId: {
    type: Number,
    default: null
  }
})
// 取消
const emit = defineEmits(['jumpTo'])
// 渲染数据
const info = reactive({
  base: {}, // 基本信息
  offLImgs: [] // 门诊病历图片
})
// 西药处方笺详情
const westernPList = ref([])
// 区分线上线下的判断条件 !important
const isOnLine = ref(true)
// 区分是否是HIS门诊病历
const isHisOffLineRecord = ref(false)
// 线上病历药品信息数据
const onLineTableData = reactive({
  //中药处方实例（历史数据兼容）
  chineseMedicineInfo: {
    isHave: false,
    data: [],
    recommendId: null
  },
  //协定方实例
  protocolPrescriptionInfos: {
    isHave: false,
    data: [],
    recommendId: null
  },
  //西药实例
  westernMedicineList: {
    isHave: false,
    data: [],
    recommendId: null
  }
})
// 病历信息项
const recordLabels = ref(onLineRecordConf.BASE_INFO)
// 数据加载loading
const loading = ref(false)
// 患者是否可见标识
const patientIsSee = require('@/assets/img/work-place/see-not.png')
// 查看处方详情显示隐藏
const PreBtnVisible = ref(false)
const DrugTraceRecordRef = ref(null)
// 处方药品追溯码记录
const traceRecordsList = ref([])
// 核验历史按钮是否展示
const isTraceRecordShow = ref(false)

watch(
  [() => prop.MRecordType, () => prop.visible, () => prop.MOperateType],
  ([type, visible, operateType]) => {
    if (!visible) return
    isHisOffLineRecord.value = type === 'offLineRecord' && operateType === 13
    isOnLine.value = type === 'onLineRecord'
    calcTemplate()
    getDetail()
  },
  {
    immediate: true,
    deep: true
  }
)

watch(
  () => info.base,
  val => {
    if (val && val.offlineSerialNumber) {
      hasTraceRecord()
    }
  },
  {
    deep: true
  }
)

const hasTraceRecord = async () => {
  try {
    const res = await judgeTraceRecords({ prescriptionCode: info.base.offlineSerialNumber })
    if (res) {
      const listRes = await listTraceRecords({ prescriptionCode: info.base.offlineSerialNumber })
      traceRecordsList.value = listRes || []
      isTraceRecordShow.value = true
    } else {
      isTraceRecordShow.value = false
      traceRecordsList.value = []
    }
  } catch (error) {
    console.log('Error fetching trace records:', error)
  }
}

// 生成配置信息
function calcTemplate() {
  recordLabels.value = []
  // 采用 [...onLineRecordConf.BASE_INFO] 实现单层深拷贝
  // 不能使用 JSON.parse(JSON.stringify()) 否则会过滤掉 render 函数
  recordLabels.value = isHisOffLineRecord.value
    ? offLineRecordConf.HIS_RECORD_INFO
    : isOnLine.value
    ? [...onLineRecordConf.BASE_INFO]
    : offLineRecordConf.RECORD_INFO

  console.log('recordLabels.value', recordLabels.value)
}

function getDetail() {
  loading.value = true
  console.log('prop.recordIsPre', prop.recordIsPre)
  if (prop.recordIsPre === '0') {
    return GetPreRecordDetail()
  }
  isHisOffLineRecord.value
    ? GetOffLineHisRecordDetail()
    : isOnLine.value
    ? GetOnLineRecordDetail()
    : GetOffLineRecordDetail()
}

// 获取预门诊病历详情
function GetPreRecordDetail() {
  isDetailIllnessPreById({ id: prop.MRecordId })
    .then(res => {
      info.base = res
      info.base.diagnosisInfoList = res.diagnosisList
      info.base.imgUrls = connectPrescriptionImages(res)
      // info.offLImgs = res.imgUrls
    })
    .finally(() => (loading.value = false))
}
// 初始化各类型药品详情数据
const setOnLineTableData = res => {
  //中药 兼容历史协定方数据
  onLineTableData.chineseMedicineInfo = {
    isHave: Boolean(res.chineseMedicineInfo),
    data:
      res.instanceBusinessType == 1
        ? [
            {
              prescriptionName: res.prescriptionName,
              prescriptionNumber: res.prescriptionNumber
            }
          ]
        : res.chineseMedicineInfo
  }
  //协定方
  onLineTableData.protocolPrescriptionInfos = {
    isHave: res.protocolPrescriptionInfos && res.protocolPrescriptionInfos.length > 0,
    data: res.protocolPrescriptionInfos
  }
  //西药
  onLineTableData.westernMedicineList = {
    isHave: res.westernMedicineList && res.westernMedicineList.length > 0,
    data: res.westernMedicineList
  }
}
// 获取线上病历详情
function GetOnLineRecordDetail() {
  onLineRecordDetail({ id: prop.MRecordId })
    .then(res => {
      console.log('GetOnLineRecordDetail', res)
      info.base = res
      const { COMMON } = onLineRecordConf
      const Indicators = COMMON
      recordLabels.value.splice(3, 0, ...Indicators)
      setOnLineTableData(res)
      PreBtnVisible.value = Boolean(info.base.prescriptionNumber)
      // 获取西药处方笺数据
      westernPList.value = res?.prescriptionInstanceInfos?.filter(item => item.recomType === 1)
    })
    .finally(() => (loading.value = false))
}
//如果处方图片有就拼接处方图片
function connectPrescriptionImages(res) {
  const { prescriptionInfo = null, imgUrls = [] } = res
  const { prescriptionImages = [] } = prescriptionInfo || {}
  //imgUrls.concat(prescriptionImages)
  if (prescriptionImages && prescriptionImages.length > 0) {
    return imgUrls.concat(prescriptionImages)
  } else {
    return imgUrls && imgUrls.length > 0 ? imgUrls : []
  }
}

// 获取门诊病历详情
function GetOffLineRecordDetail() {
  offLineRecordDetail({ id: prop.MRecordId })
    .then(res => {
      console.log('GetOffLineRecordDetail', res)
      info.base = res
      info.base.imgUrls = connectPrescriptionImages(res)
      // info.offLImgs = res.imgUrls
    })
    .finally(() => (loading.value = false))
}

function calcEmptyText(val, replace = '--') {
  if (!val) return ` ${replace} `
  return ` ${val} `
}

// 获取his门诊病历详情
function GetOffLineHisRecordDetail() {
  const { MPid, MRecordId, MOperateType, MHospitalId, MUcPatientId } = prop
  const params = {
    pid: MPid,
    medicalRecordId: MRecordId,
    operateType: MOperateType,
    hospitalId: MHospitalId,
    ucPatientId: MUcPatientId
  }
  hisOffLineRecordDetail(params)
    .then(res => {
      info.base = res
    })
    .finally(() => (loading.value = false))
}

const handleHistory = () => {
  DrugTraceRecordRef.value.setVisible(true)
}
</script>

<style lang="scss" scoped>
.medical-record-detail {
  .head {
    .head-left {
      font-weight: bold;
      font-size: 16px;
      color: #333333;
    }
  }
  position: relative;
  .chapter {
    position: absolute;
    top: 120px;
    right: 32px;
    .daChapterImg {
      margin-top: 9px;
    }
  }
  .patientIsSee {
    position: absolute;
    right: 0;
    top: 35px;
  }
  .annotationBox {
    display: flex;
    .history {
      color: #1989fa;
      font-size: 14px;
      cursor: pointer;
    }
  }
  .annotation {
    text-align: right;
    line-height: 25px;
    color: #999999;
    font-weight: 400;
    span {
      margin-left: 28px;
    }
  }
  .baseTitle {
    font-size: 14px;
    font-weight: bold;
    color: #333333;
    margin-bottom: 25px;
    .img-container {
      margin-top: 8px;
    }
  }
  .header {
    font-size: 12px;
    color: #999999;
    text-align: right;
  }
  .detail_info {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    margin-left: 0 !important;
    &-item {
      font-size: 14px;
      margin-bottom: 20px;
      padding-right: 8px;
      .item_label {
        font-weight: 550;
        color: #333333;
      }
      .item_content {
        font-weight: 400;
        color: #666666;
      }
      .link_content {
        color: #1890ff;
        cursor: pointer;
      }
      .img_content {
        display: flex;
        margin: 0;
      }
    }

    .sLabel {
      width: 25%;
    }

    .mLabel {
      width: 50%;
    }
    .lLabel {
      width: 100%;
    }
  }
  .recordImg {
    width: 140px;
    height: 120px;
    overflow: hidden;
    margin: 4px 12px 12px 0;
    ::v-deep(.ant-image-img) {
      object-fit: cover;
    }
  }
  .separateLine {
    background-color: rgba(0, 0, 0, 0.09);
    margin-bottom: 24px !important;
  }
  ::v-deep(.ant-image) {
    .medical-img {
      overflow: hidden;
      margin: 8px 12px 12px 0;
    }
  }
  ::v-deep(.ant-divider-horizontal) {
    margin: 0;
  }
  ::v-deep(.emptySlot) {
    img {
      width: 80px;
      height: 80px;
    }
  }
}
</style>
